import React from 'react';
import styled from 'styled-components/macro';
import Button from 'jsx/elements/buttons/Button';

import { api } from 'api';
import Spinner from 'jsx/elements/spinner';
import useLocale from 'jsx/locale/useLocale';
import { DatePicker } from 'components/DatePicker';
import { Select } from 'components/Select';
import { Comments } from './Comments';

export const getNewDate = date => {
  return new Date(date); //.toISOString();
};
export const ApplicationActions = ({ application, showMessage }) => {
  const [comments, setComments] = React.useState(application.reviewerComment);

  const [fromDate, setFromDate] = React.useState(getNewDate(application.freezeLoanFrom));
  const [toDate, setToDate] = React.useState(getNewDate(application.freezeLoanTo));
  const [action, setAction] = React.useState(1);

  if (!application) return <Spinner center size="medium" />;

  const saveApplication = async action => {
    let data = {
      applicationGuid: application.applicationGuid,
      reviewerComment: comments,
      freezeLoanFrom: fromDate,
      freezeLoanTo: toDate
    };
    if (action === 1) {
      let res = await api.approveApplication(data);
      if (res && res.error) {
        showMessage({ message: res.error.message, type: 'alert' });
      } else {
        showMessage({
          message: 'Umsókn hefur verið samþykkt og tilkynningar sendar á aðra lánveitendur',
          type: 'success'
        });
      }
    }
    if (action === 2) {
      let res = await api.declineApplication(data);
      if (res && res.error) {
        showMessage({ message: res.error.message, type: 'alert' });
      } else {
        showMessage({
          message: 'Umsókn hefur verið hafnað og tilkynningar sendar á aðra lánveitendur',
          type: 'success'
        });
      }
    }
    if (action === 3) {
      let res = await api.putApplicationOnHold(data);
      if (res && res.error) {
        showMessage({ message: res.error.message, type: 'alert' });
      } else {
        showMessage({
          message: 'Umsókn hefur sett í biðstöðu, engar tilkynningar eru sendar vegna þessa',
          type: 'success'
        });
      }
    }
    // if (action === 4) {
    //   api.deleteApplication(data.applicationGuid);
    // }
  };

  return (
    <>
      <div
        className="gutter-top border-top"
        style={{ display: 'flex', justifyContent: 'space-between' }}
      ></div>
      <div className="grid gutter-bottom gutter">
        <div className="col s1of2">
          <div className=" " style={{ display: 'flex', justifyContent: 'space-between' }}></div>
          <Select items={actions} defaultValue={1} onChange={value => setAction(value)} />
        </div>
        {action === 1 && (
          <div className="col s1of2">
            <div className="grid">
              <div className="col s1of3 text-right">
                <span className="text-14"> </span>
                <div style={{ marginRight: 15, marginTop: 3 }}>Gildistími:</div>
              </div>

              <div className="col s1of3">
                <div className="text-14 pull-left" style={{ marginTop: 3 }}>
                  Frá
                </div>
                <div style={{ width: '80%', float: 'left', marginLeft: 5 }}>
                  {/* {isoDate(fromDate)} */}
                  <DatePicker
                    onChange={a => setFromDate(a)}
                    value={fromDate}
                    selected={fromDate}
                    disabled={action !== 1}
                  />
                </div>
              </div>
              <div className="col s1of3">
                <div className="text-14 pull-left" style={{ marginTop: 3 }}>
                  Til
                </div>
                <div style={{ width: '80%', float: 'left', marginLeft: 5 }}>
                  {/* {toDate} */}
                  <DatePicker
                    onChange={a => setToDate(a)}
                    value={toDate}
                    selected={toDate}
                    disabled={action !== 1}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <Comments comments={comments} onChange={e => setComments(e.target.value)} />
      <div className="text-right">
        <Button
          text={'vista'}
          className={'large'}
          color={'red'}
          onClick={() => saveApplication(action)}
        />
      </div>
    </>
  );
};

const actions = [
  { display: 'Samþykkja umsókn og senda tilkynningar', value: 1 },
  { display: 'Hafna umókn', value: 2 },
  { display: 'Umsókn fer á bið', value: 3 }
];
